const css = `.user-display {
  display: flex;
  align-items: center;
  gap: 12px;
}
.user-display .p-button {
  height: 32px;
  margin: unset;
}
.user-display .p-button.p-button-icon-only {
  width: 32px;
}
.user-display .user-info {
  display: flex;
  flex-direction: column;
}
.user-display .user-info .user-name {
  margin: 0;
}
.user-display .user-info .user-name.clickable {
  cursor: pointer;
}
.user-display .user-info .user-name.clickable:hover {
  text-decoration: underline;
}
.user-display .user-info:has(.user-phone-container) .user-name {
  margin-top: 4px;
}
.user-display .user-info .user-phone-container {
  display: flex;
  align-items: center;
  gap: 4px;
  margin: var(--space-0-5) 0 var(--space-2);
}
.user-display .user-info .user-phone-container .user-phone,
.user-display .user-info .user-phone-container i {
  font-size: var(--font-size-xs);
  color: var(--text-color-secondary);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL29wdC9yZW5kZXIvcHJvamVjdC9zcmMvc3JjL2NvbXBvbmVudHMvVXNlckRpc3BsYXkiLCJzb3VyY2VzIjpbIlVzZXJEaXNwbGF5LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTtFQUNBOztBQUNBO0VBQ0U7O0FBSUo7RUFDRTtFQUNBOztBQUVBO0VBQ0U7O0FBQ0E7RUFDRTs7QUFDQTtFQUNFOztBQU1KO0VBQ0U7O0FBR0o7RUFDRTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtBQUFBO0VBRUU7RUFDQSIsInNvdXJjZXNDb250ZW50IjpbIi51c2VyLWRpc3BsYXkge1xuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBnYXA6IDEycHg7XG5cbiAgLnAtYnV0dG9uIHtcbiAgICBoZWlnaHQ6IDMycHg7XG4gICAgbWFyZ2luOiB1bnNldDtcbiAgICAmLnAtYnV0dG9uLWljb24tb25seSB7XG4gICAgICB3aWR0aDogMzJweDtcbiAgICB9XG4gIH1cblxuICAudXNlci1pbmZvIHtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG5cbiAgICAudXNlci1uYW1lIHtcbiAgICAgIG1hcmdpbjogMDtcbiAgICAgICYuY2xpY2thYmxlIHtcbiAgICAgICAgY3Vyc29yOiBwb2ludGVyO1xuICAgICAgICAmOmhvdmVyIHtcbiAgICAgICAgICB0ZXh0LWRlY29yYXRpb246IHVuZGVybGluZTtcbiAgICAgICAgfVxuICAgICAgfVxuICAgIH1cblxuICAgICY6aGFzKC51c2VyLXBob25lLWNvbnRhaW5lcikge1xuICAgICAgLnVzZXItbmFtZSB7XG4gICAgICAgIG1hcmdpbi10b3A6IDRweDtcbiAgICAgIH1cbiAgICB9XG4gICAgLnVzZXItcGhvbmUtY29udGFpbmVyIHtcbiAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgICAgZ2FwOiA0cHg7XG4gICAgICBtYXJnaW46IHZhcigtLXNwYWNlLTAtNSkgMCB2YXIoLS1zcGFjZS0yKTtcblxuICAgICAgLnVzZXItcGhvbmUsXG4gICAgICBpIHtcbiAgICAgICAgZm9udC1zaXplOiB2YXIoLS1mb250LXNpemUteHMpO1xuICAgICAgICBjb2xvcjogdmFyKC0tdGV4dC1jb2xvci1zZWNvbmRhcnkpO1xuICAgICAgfVxuICAgIH1cbiAgfVxufVxuIl19 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
